import axiosInstance from "./interceptors/token";
import { API_BASE_URL } from "./constants";



export const translateText = async (text, targetLanguage) => {
    if (targetLanguage === 'ne') 
        targetLanguage = 'nl';
    try {
        const response = await axiosInstance.post(API_BASE_URL + "translate/", {
            text: text,
            target: targetLanguage,
        });
        return response.data.translation
    } catch (error) {
        console.error("Error translating text:", error);
        return text;
    }
}

export const getCurrentDate = (selectedDate) => {
    if (selectedDate) {
        return selectedDate;
    }
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export default translateText;


